import { Settings } from "./settings";

export const symbolData = {
  0: {
    name: "w1",
    spine: "w1",
    symbolPay: "wild",
    texture: "w1",
    value: null,
  },
  1: {
    name: "h1",
    spine: "h1",
    symbolPay: "hp",
    texture: "h1",
    value: null,
  },
  2: {
    name: "h2",
    spine: "h2",
    symbolPay: "hp",
    texture: "h2",
    value: null,
  },
  3: {
    name: "m1",
    spine: "m1",
    symbolPay: "mp",
    texture: "m1",
    value: null,
  },
  4: {
    name: "m2",
    spine: "m2",
    symbolPay: "mp",
    texture: "m2",
    value: null,
  },
  5: {
    name: "m3",
    spine: "m3",
    symbolPay: "mp",
    texture: "m3",
    value: null,
  },
  6: {
    name: "l1",
    spine: "l1",
    symbolPay: "lp",
    texture: "l1",
    value: null,
  },
  7: {
    name: "l2",
    spine: "l2",
    symbolPay: "lp",
    texture: "l2",
    value: null,
  },
  8: {
    name: "l3",
    spine: "l3",
    symbolPay: "lp",
    texture: "l3",
    value: null,
  },
  9: {
    name: "l4",
    spine: "l4",
    symbolPay: "lp",
    texture: "l4",
    value: null,
  },
  10: {
    name: "l5",
    spine: "l5",
    symbolPay: "lp",
    texture: "l5",
    value: null,
  },
  11: {
    name: "l6",
    spine: "l6",
    symbolPay: "lp",
    texture: "l6",
    value: null,
  },
  12: {
    name: "sc1",
    spine: "sc1",
    symbolPay: "scatter",
    texture: "sc1",
    value: null,
  },
};

// Wild symbol configuration - calculated from SymbolData once at module load
export const WILD_SYMBOL_ID = (() => {
  const found = Object.entries(symbolData).find(
    ([, data]) => data.name === "w1",
  );
  return found ? parseInt(found[0]) : null;
})();

// Scatter symbol configuration - calculated from SymbolData once at module load
export const SCATTER_SYMBOL_ID = (() => {
  const found = Object.entries(symbolData).find(
    ([, data]) => data.symbolPay === "scatter",
  );
  return found ? parseInt(found[0]) : null;
})();

// Scatter symbol IDs - all symbols with symbolPay === "scatter"
export const SCATTER_SYMBOL_IDS = (() => {
  return Object.entries(symbolData)
    .filter(([, data]) => data.symbolPay === "scatter")
    .map(([id]) => parseInt(id));
})();

// Individual scatter symbol IDs - calculated from SymbolData by name
export const SCATTER_1_SYMBOL_ID = (() => {
  const found = Object.entries(symbolData).find(
    ([, data]) => data.name === "sc1",
  );
  return found ? parseInt(found[0]) : null;
})();

export const SCATTER_2_SYMBOL_ID = (() => {
  const found = Object.entries(symbolData).find(
    ([, data]) => data.name === "sc2",
  );
  return found ? parseInt(found[0]) : null;
})();

/**
 * Blank symbol ID - represents empty spaces on the grid
 * Used in Hold and Win mode for empty positions
 */
export const BLANK_SYMBOL_ID = 0;

// Coin symbol IDs - all symbols with texture === "c"
export const COIN_SYMBOL_IDS = (() => {
  return Object.entries(symbolData)
    .filter(([, data]) => data.texture === "c")
    .map(([id]) => parseInt(id));
})();

// Probability of generating a coin symbol during random spin/buffer generation (0.035 = 3.5% chance)
export const COIN_GENERATION_PROBABILITY = 0.035;

// Helper function to check if a symbol ID is a coin
export const isCoinSymbol = (symbolId) => {
  if (symbolId === null || symbolId === undefined) return false;
  return COIN_SYMBOL_IDS.includes(symbolId);
};

// Low-pay symbol IDs - for default slotface generation (no winning combos)
export const LOW_PAY_SYMBOL_IDS = (() => {
  return Object.entries(symbolData)
    .filter(([, data]) => data.symbolPay === "lp")
    .map(([id]) => parseInt(id));
})();

/**
 * Default slotface - programmatically generated grid of low-pay symbols.
 * Produces REEL_COUNT arrays of SYMBOLS_VISIBLE length, cycling through
 * low-pay symbols so no reel shows the same symbol as its neighbor.
 */
export const DEFAULT_SLOTFACE = (() => {
  const { REEL_COUNT, SYMBOLS_VISIBLE } = Settings;
  const lp = LOW_PAY_SYMBOL_IDS;

  return Array.from({ length: REEL_COUNT }, (_, reelIndex) =>
    Array.from({ length: SYMBOLS_VISIBLE }, (_, rowIndex) =>
      lp[(reelIndex + rowIndex) % lp.length]
    )
  );
})();
